import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

import Header from './header';
import Footer from './footer';

import i18n from '../../i18n';

import './cookiesPolicy.css'

export default class CookiesPolicy extends Component {

    constructor(props) {
        super(props);

        var tLang = 2;
        document.getElementsByTagName("html")[0].setAttribute("lang", "en")
        if (i18n.language == "hr") {
            document.getElementsByTagName("html")[0].setAttribute("lang", "hr")
            tLang = 1;
        }
    }


    render() {
        return (
            <React.Fragment>
                <Header />
                <main>
                    <Container fluid>


                        <br />
                        <br />
                        <br />
                        <br />
                        <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <section>
                                <Container>
                                    <h1>{i18n.t("cookies:naslov")}</h1>
                                </Container>
                            </section>


                            <br />
                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("cookies:kolacici")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("cookies:kolacici_tekst")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("cookies:nuzni_kolacici")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("cookies:nuzni_kolacici_tekst")}
                                    </p>

                                    <p>
                                        {i18n.t("cookies:kolacici_reCaptcha")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("cookies:vrste_kolacica")}</h2>
                                    <br />

                                    <table>
                                        <thead>
                                        <tr>
                                            <th>{i18n.t("cookies:naziv")}</th>
                                            <th>{i18n.t("cookies:pruzatelj")}</th>
                                            <th>{i18n.t("cookies:svrha")}</th>
                                            <th>{i18n.t("cookies:trajanje")}</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr>
                                            <td>{i18n.t("cookies:naziv_tekst")}</td>
                                            <td>{i18n.t("cookies:pruzatelj_tekst")}</td>
                                            <td>{i18n.t("cookies:svrha_tekst")}</td>
                                            <td>{i18n.t("cookies:trajanje_tekst")}</td>
                                        </tr>
                                        </tbody>
                                    </table>


                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("cookies:preglednik")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("cookies:preglednik_tekst")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                        </div>
                        <br />

                    </Container >
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}